import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 20px;
`;

export const ColorValue = styled.div`
  color: #889;
`;

export const Input = styled.input`
  width: 60px;
`;
